<template>
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast show mb-2 border shadow-sm"
      role="alert"
    >
      <!-- Cabeçalho -->
      <div class="toast-header justify-content-between" :class="headerClass(toast.type)">
        <strong class="me-auto fs-6">{{ toast.title || 'Notificação' }}</strong>
        <button
          type="button"
          class="btn-close btn-close-black"
          aria-label="Fechar"
          @click="removeToast(toast.id)"
        ></button>
      </div>

      <!-- Corpo -->
      <div class="toast-body">
        <component v-if="isComponent(toast.content)" :is="toast.content" />
        <span v-else>{{ toast.content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from '../../hooks';

export default {
  setup() {
    const { toasts, removeToast } = useToast();

    const toastClass = (type) => {
      return {
        'toast-success': type === 'success',
        'toast-error': type === 'error',
        'toast-warning': type === 'warning',
        'toast-info': type === 'info',
      };
    };

    const headerClass = (type) => {
      return {
        'bg-success text-dark': type === 'success',
        'bg-danger text-white': type === 'error',
        'bg-warning text-dark': type === 'warning',
        'bg-primary text-dark': type === 'info',
      };
    };

    const isComponent = (content) => typeof content === 'object' || typeof content === 'function';

    return { toasts, removeToast, toastClass, headerClass, isComponent };
  },
};
</script>

<style scoped>
.toast-container {
  max-width: 380px;
}

.toast {
  background-color: white;
  color: #212529;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.toast-header {
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.toast-body {
  padding: 0.75rem;
  font-size: 0.95rem;
}
</style>
